import { Component, Input, OnInit } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-header-label',
    template: `<div >
    <ng-content>{{ headerLabel | translation: translationRequest }}</ng-content>
  </div>`,
    styles: [],
    standalone: false
})
export class HeaderLabelComponent implements OnInit {
  @Input()
  type: HeaderLabelType = 'Header2';

  @Input()
  headerLabel: string;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });
  constructor() {}

  ngOnInit(): void {}

  get headerClass() {
    return {
      'app-header-1': this.type === 'Header1',
      'app-header-2': this.type === 'Header2',
      'app-header-3': this.type === 'Header3',
    };
  }
}

type HeaderLabelType = 'Header1' | 'Header2' | 'Header3';
